import { v4 as uuidv4 } from "uuid";
import Picklist from "./picklist";
import runAfterPageLoad from '~/src/runAfterPageLoad'

export default class ChannelsPicklist extends Picklist {
  static createInstance(picklistToInit) {
    const { instanceId } = picklistToInit.dataset;
    if (!window.hasOwnProperty("Picklists")) window.Picklists = [];

    if (instanceId) return;
    picklistToInit.style.display = "block";
    const id = uuidv4();
    const instance = new Picklist(picklistToInit);
    window.Picklists.push({ id, instance });
    picklistToInit.dataset.instanceId = id;
  }

  static init() {
    runAfterPageLoad(() => {
      document.querySelectorAll(".resources-container").forEach((container) => {
        ChannelsPicklist.createInstance(container);
      });
    })
    window.addEventListener("widgetsUpdated", () => {
      document.querySelectorAll(".resources-container").forEach((item) => {
        ChannelsPicklist.createInstance(item);
      });
    });
  }
}
